import { connect } from 'react-redux'
import { PackDeleteComponent } from './PackDeleteButton'
import { selectActiveModal } from '../../selectors/modal'

const mapStateToProps = (state) => ({
  activeModal: selectActiveModal(state),
})

export const PackDeleteButton = connect(mapStateToProps)(PackDeleteComponent)
